import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl font-bold mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors">八仔漫画</Link>
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              国内领先的正版漫画在线阅读平台，让好漫画触手可及。万部正版漫画，免费畅读，纯净无广告。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">热门分类</h4>
            <ul className="space-y-2">
              {comicCategories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">全部漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">玄幻奇幻</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@bazai-comics.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>浙江省杭州市余杭区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2018-2026 八仔漫画网 版权所有 | 本站所有漫画均为正版授权内容
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}